import { render, staticRenderFns } from "./preference-select.vue?vue&type=template&id=3ac01b58"
import script from "./preference-select.vue?vue&type=script&lang=js"
export * from "./preference-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports